<template>
</template>

<script>
    export default {
        name: "NotificationWS",

        mounted() {
            const user_id = window.user_id
            window.Echo.channel(`confirmation.${user_id}.notifications`)
                .listen('.NotificationMaster', (e) => {
                    const { message, type } = e
                    if (message && type) {
                        this.$message({
                            message,
                            type
                        })
                    }
                })
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/common/NotificationWS.vue